import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/view/components/TabsTable'
import { Separator } from '@/view/components/ui/separator'
import { LiveCard } from './components/LiveCard'
import { LiveList } from './components/LiveList'
import { TrainingTable } from './components/TrainingTable'
import useContentsPage, { ContentsTab } from './hooks/useContentPages'
import { MaterialPage } from './MaterialPage'
import { CreateMaterialDialogProvider } from './providers/CreateMaterialDialogProvider'
import { LiveFormProvider } from './providers/LiveFormProvider'
import { TrainingFormProvider } from './providers/TraningFormProvider'

export const ContentsAdmin = () => {
  const { selectedTab, setSelectedTab } = useContentsPage()

  const handleChangeTab = (tab: string) => {
    setSelectedTab(tab as ContentsTab)
  }

  const isTraining = selectedTab === 'training'

  return (
    <div className="flex min-h-full w-full flex-1 justify-between gap-8">
      <LiveFormProvider>
        <Tabs
          defaultValue={selectedTab}
          className="flex-1"
          value={selectedTab}
          onValueChange={handleChangeTab}
        >
          <div className="flex items-center">
            <TabsList className="flex items-center gap-8">
              <TabsTrigger className="text-xl" value="training">
                Treinamentos
              </TabsTrigger>
              <TabsTrigger className="text-xl" value="material">
                Materiais
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="training" className="mt-8 w-full">
            <LiveCard />

            <Separator className="mt-5" />
            <TrainingFormProvider>
              <TrainingTable />
            </TrainingFormProvider>
          </TabsContent>
          <TabsContent value="material">
            <CreateMaterialDialogProvider>
              <MaterialPage />
            </CreateMaterialDialogProvider>
          </TabsContent>
        </Tabs>
        {isTraining && <LiveList />}
      </LiveFormProvider>
    </div>
  )
}
